import { createClient, createConfig } from '@hey-api/client-fetch';

import { createClientConfig } from '../../config/account.client';
import { API_KIT_ONLY_ENDPOINT_ACCOUNT_API_PROD } from '../config';

import type { Client } from '@hey-api/client-fetch';

/**
 * Creates a client for the production API
 */
export const createAccountProductionClient = (): Client => {
  const config = {
    ...createClientConfig(createConfig()),
    baseUrl: API_KIT_ONLY_ENDPOINT_ACCOUNT_API_PROD,
  };

  return createClient(config);
};
